/** @format */
import { MediaQuery } from '@mpb-com/feather/helpers/media-queries';

import { ConstrainedWrapperGutter, ConstrainedWrapperSize } from './index';

export const getMaxWidthSize = (size?: ConstrainedWrapperSize) => {
    switch (size) {
        case ConstrainedWrapperSize.S_312:
            return '31.2rem';

        case ConstrainedWrapperSize.S_552:
            return '55.2rem';

        case ConstrainedWrapperSize.S_720:
            return '72rem';

        case ConstrainedWrapperSize.S_1080:
            return '108rem';

        case ConstrainedWrapperSize.S_1280:
            return '128rem';

        case ConstrainedWrapperSize.S_1440:
        default:
            return '144rem';
    }
};

export const getGutterSize = (
    mediaQuery: MediaQuery,
    gutter?: ConstrainedWrapperGutter
) => {
    switch (gutter) {
        case ConstrainedWrapperGutter.LARGE_GUTTER:
            switch (mediaQuery) {
                case MediaQuery.SMALL_MOBILE:
                case MediaQuery.MOBILE:
                    return 'var(--layout-spacing-24)';
                default:
                    return 'var(--layout-spacing-48)';
            }
        case ConstrainedWrapperGutter.SMALL_GUTTER:
            switch (mediaQuery) {
                case MediaQuery.SMALL_MOBILE:
                case MediaQuery.MOBILE:
                    return 'var(--layout-spacing-12)';
                default:
                    return 'var(--layout-spacing-24)';
            }
        case ConstrainedWrapperGutter.VARIABLE_GUTTER:
            switch (mediaQuery) {
                case MediaQuery.SMALL_MOBILE:
                case MediaQuery.MOBILE:
                    return 'var(--layout-spacing-12)';
                default:
                    return 'var(--layout-spacing-48)';
            }
        default:
            switch (mediaQuery) {
                case MediaQuery.SMALL_MOBILE:
                case MediaQuery.MOBILE:
                case MediaQuery.SMALL_TABLET:
                case MediaQuery.LARGE_TABLET:
                    return 'var(--layout-spacing-16)';
                case MediaQuery.DESKTOP:
                    return 'var(--layout-spacing-32)';
                case MediaQuery.LARGE_DESKTOP:
                default:
                    return 'var(--layout-spacing-96)';
            }
    }
};

export const getGridTemplateColumns = (
    mediaQuery: MediaQuery,
    gutter?: ConstrainedWrapperGutter,
    size?: ConstrainedWrapperSize
) => {
    const gutterSize = getGutterSize(mediaQuery, gutter);
    const maxWidth = getMaxWidthSize(size);
    const paddedColumn = `minmax(${gutterSize}, calc((100% - ${maxWidth}) / 2 + ${gutterSize}))`;

    return `${paddedColumn} minmax(0, 1fr) ${paddedColumn}`;
};

export const getPadding = (
    mediaQuery: MediaQuery,
    gutter?: ConstrainedWrapperGutter
) => {
    return `0 ${getGutterSize(mediaQuery, gutter)}`;
};
